import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExportmisreportService {

  constructor(private http:HttpClient) { }
  getDetails(fromDate, toDate){
    let url = `${environment.apiUrl}/MisReport/getMisReportData/`+fromDate+`/`+toDate;
    return this.http.get(url);
  }
}
